/**
 * TrackingProvider Component
 * ==========================
 * 
 * Wrapper component that:
 * - Initializes tracking on mount
 * - Tracks page views on route changes
 * - Provides tracking context to children
 */

import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { initTracking, trackPageView, getAnonymousId } from '../lib/tracking';

const TrackingProvider = ({ children }) => {
  const location = useLocation();
  const isInitialized = useRef(false);
  const lastPath = useRef(null);

  // Initialize tracking on mount
  useEffect(() => {
    if (!isInitialized.current) {
      initTracking();
      isInitialized.current = true;
      lastPath.current = location.pathname;
    }
  }, []);

  // Track page views on route change
  useEffect(() => {
    if (isInitialized.current && location.pathname !== lastPath.current) {
      trackPageView(location.pathname);
      lastPath.current = location.pathname;
    }
  }, [location.pathname]);

  return <>{children}</>;
};

export default TrackingProvider;
